import { render, staticRenderFns } from "./ManualImportConfigModal.vue?vue&type=template&id=07fc36ae&scoped=true"
import script from "./ManualImportConfigModal.vue?vue&type=script&lang=js"
export * from "./ManualImportConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ManualImportConfigModal.vue?vue&type=style&index=0&id=07fc36ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc36ae",
  null
  
)

export default component.exports